import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextarea,_vm._b({attrs:{"label":_vm.$t('Alt'),"outlined":"","hide-details":"auto"},model:{value:(_vm.alt),callback:function ($$v) {_vm.alt=$$v},expression:"alt"}},'v-textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }